<div class="login-wrapper" fxLayout="row" fxLayoutAlign="center center">

    <mat-card class="login-form">

        <mat-card-header>

            <div style="width: 100%;">
                <img class="login-logo" src="../../../assets/img/login_logo.png" />

            </div>

        </mat-card-header>


        <!-- <div *ngIf="showPasswordResetProgressSpinner" class="spinner-wrapper">
            <mat-spinner class="spinner-inner"></mat-spinner>
        </div> -->


        <div style="display: flex; justify-content: center; margin: 32px 0;">
            <p style="display: {{'es' | translate}};color: green; font-size: 18px">
                El pedido con referencia <span class="payment-ref">{{ paymentRef }}</span> se ha realizado con
                éxito.
            </p>
            <p style="display: {{'cat' | translate}};color: green; font-size: 18px">
                La comanda amb referència <span class="payment-ref">{{ paymentRef }} </span> s'ha realitzat amb
                èxit.
            </p>
            <p style="display: {{'en' | translate}};color: green; font-size: 18px">
                The order with reference: <span class="payment-ref">{{paymentRef}} </span> has been successful.
            </p>
        </div>


        <div>
            <button mat-flat-button class="backButton" [ngClass]="{'success': success}" routerLink="/orders">
                <mat-icon>arrow_back</mat-icon>
                <span>&nbsp; {{'buttons.return' | translate}}</span>
            </button>
        </div>
    </mat-card>


</div>